import memoize from 'memoize-one';
import React from 'react';
import ReactWebChat, { createDirectLine } from 'botframework-webchat';
import SearchCard from './components/SearchCard';
import DefaultCard from "./components/DefaultCard";
import ConfirmationCard from "./components/ConfirmationCard";

import { scheduleJob } from "node-schedule";

import './WebChat.css';

export default class WebChat extends React.Component {
    constructor(props) {
        super(props);

        this.createDirectLine = memoize(token => createDirectLine({ token }));

        props.store.subscribe((e) => {
            let botState = this.props.store.getState();
            if (botState.connectivityStatus === 'connected' &&
                botState.activities.length > 0 && this.state.loading) {
                this.setState({ loading: false });
            }

            let timeout = botState.activities.filter(x => {
                return x.type === 'webchat/setTimeout';
            });

            if (timeout.length > 0) {
                botState.activities = botState.activities.filter(x => {
                    return x.type !== 'webchat/setTimeout';
                });
                const min = timeout[0].value / 10000;
                scheduleJob("timeout", min + ' * * * * *', function (sto, expTime) {
                    let stateTimeout = sto.getState();
                    let lastTime = null;
                    let firstEnd = true;

                    stateTimeout.activities.forEach(item => {
                        if (item.type === 'message') {
                            let temp = new Date(item.timestamp);
                            if (!lastTime) {
                                lastTime = temp;
                            }

                            if (temp > lastTime) {
                                firstEnd = item.text.includes("Olá") || item.text.includes("Identifiquei");
                                lastTime = temp;
                            }
                        }
                    });

                    if (Math.abs(new Date() - lastTime) / 100 >= expTime && !firstEnd) {
                        stateTimeout.activities.forEach(item => {
                            item.suggestedActions = [];
                        });
                        sto.dispatch({
                            type: 'WEB_CHAT/SEND_EVENT',
                            payload: {
                                name: 'webchat/inativo'
                            }
                        });
                    }
                }.bind(null, this.props.store, timeout[0].value));
            }

            botState.activities = botState.activities.filter(x => {
                return (x.type !== 'event' && x.text !== 'Confirmation|resp') || x.type !== 'webchat/setTimeout';
            });

            if (botState.suggestedActions.length > 0) {
                botState.suggestedActions = [];
            }
        });

        const attachmentMiddleware = () => next => card => {
            const type = card.activity.value;
            switch (type) {
                case 'application/searchcard':
                    return (<SearchCard store={props.store} actions={card.activity.suggestedActions.actions} activity={card.activity} />);
                case 'application/faqCard':
                    return <DefaultCard activity={card.activity} store={props.store} accordion={true} />;
                case 'application/Confirmation':
                    card.activity.from.role = "user";
                    return <ConfirmationCard store={props.store} actions={card.activity.suggestedActions.actions} activity={card.activity} />;
                default:
                    return <DefaultCard activity={card.activity} store={props.store} />

            }
        };

        this.state = { attachmentMiddleware, loading: true };
    }

    getActions = (card) => {
        let actions = card.activity.suggestedActions ?
            card.activity.suggestedActions.actions
            : [];
        card.activity.suggestedActions.actions = [];
        return actions;
    }

    componentDidMount() {
        !this.props.token && this.props.onFetchToken();
    }

    render() {
        const {
            props: { className, store, token, styleSet },
            state: { attachmentMiddleware, loading }
        } = this;

        return ([loading ?
            <div key={1} className={`${className || ''} connect-spinner`}>
                <div className="content">
                    <div className="icon">
                        <span className="ms-Icon ms-Icon--Robot" />
                    </div>
                    <p>Por favor, espere um minuto.</p>
                </div>
            </div> : '',
        <ReactWebChat
            key={2}
            className={`${className || ''} web-chat`}
            directLine={this.createDirectLine(token)}
            store={store}
            styleSet={styleSet}
            attachmentMiddleware={attachmentMiddleware}
        />
        ]);
    }
}